import { ProfileFormField } from '../components/ProfileFormField';
import EntityFormProvider from '../EntityFormProvider';

export default function RiskAndInvestmentPreferences() {
  return (
    <EntityFormProvider title="Risk and investment preferences">
      <ProfileFormField
        entityType="RiskAndInvestmentPreferences"
        fieldName="attitude_to_risk"
        label="Attitude to risk"
      />
      <ProfileFormField
        entityType="RiskAndInvestmentPreferences"
        fieldName="capacity_for_loss_resilience"
        label="Capacity for loss/resilience"
      />
      <ProfileFormField
        entityType="RiskAndInvestmentPreferences"
        fieldName="knowledge_and_experience"
        label="Knowledge and experience"
      />
      <ProfileFormField
        entityType="RiskAndInvestmentPreferences"
        fieldName="charitable_considerations"
        label="Charitable considerations"
      />
      <ProfileFormField
        entityType="RiskAndInvestmentPreferences"
        fieldName="sustainable_environmental_social_governance_ethical_preferences"
        label="Sustainable, environmental, social, governance, ethical preferences"
      />
      <ProfileFormField
        entityType="RiskAndInvestmentPreferences"
        fieldName="any_religious_preferences"
        label="Any religious preferences"
      />
      <ProfileFormField
        entityType="RiskAndInvestmentPreferences"
        fieldName="structured_products_discussed"
        label="Structured products discussed"
      />
      <ProfileFormField
        entityType="RiskAndInvestmentPreferences"
        fieldName="managed_funds_and_associated_costs_discussed"
        label="Managed funds and associated costs discussed"
      />
    </EntityFormProvider>
  );
}
